import { Injectable } from '@angular/core';
import { RegularWithdrawalFrequencies, RegularWithdrawalModes } from './rest-api/rest-api';
import { RadiosKeyValueTyped } from '../shared/radio-input-group/radio-input-group';
import { LoggerService } from './logger/logger.service';
import { Dayjs } from 'dayjs';
import { ConsultClientService } from './consult-client.service';

export interface WithdrawalDraftServiceInput {
  clientId: number,
  investmentId: number,
  bankAccountId: number,
  bankAccountNumber: string,
  frequency: RegularWithdrawalFrequencies,
  mode: RegularWithdrawalModes,
  validTo: Dayjs | 'unlimited',
  message?: string,
  amount: number,
  portfolioType?: 'portfolio' | 'strategy',
  portfolioName?: string,
  withdrawRegularity?: RadiosKeyValueTyped<RegularWithdrawalFrequencies>,
}

@Injectable({
  providedIn: 'root'
})
export class WithdrawalDraftStorageService {
  private withdrawalDraft: WithdrawalDraftServiceInput | null = null;

  public constructor(
    private loggerService: LoggerService,
    private consultClientService: ConsultClientService,
  ) { }

  public setDraftForm(input: WithdrawalDraftServiceInput): void {
    this.withdrawalDraft = input;
  }

  public setDraftComment(comment: string): void {
    if(this.withdrawalDraft) {
      this.withdrawalDraft.message = comment;
    } else {
      this.loggerService.error('Attempt to set withdrawal draft comment without withdrawal draft data!')
    }
  }

  public resetDraft(): void {
    this.withdrawalDraft = null;
    this.consultClientService.removeStep('draftForm');
  }

  public getDraftData(): WithdrawalDraftServiceInput | null {
    return this.withdrawalDraft;
  }
}
